var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.441,
    height: 26.4,
    viewBox: "0 0 47.441 26.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M49.227,20.662s-10.172,12.2-22.721,12.2-22.721-12.2-22.721-12.2,10.172-12.2,22.721-12.2S49.227,20.662,49.227,20.662Z",
    transform: "translate(-3.786 -8.462)",
    fill: "none",
    stroke: "#677991",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 8.998,
    cy: 8.559,
    rx: 8.998,
    ry: 8.559,
    transform: "translate(13.644 3.708)",
    fill: "none",
    stroke: "#677991",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.319ca8b5e555b3839fb3d59ef39d485f.svg";
export { ForwardRef as ReactComponent };